// react
import { Map, List } from "immutable";

// config

// utils

export const initialState = Map({
	eventsCount: 0,
	events: List(),
	scheduledNotifications: List(),
	scheduledNotificationsCount: 0,
	notificationSnapshots: Map(),
	notificationRawEmails: Map(),
	mostRecentRequestID: Map(),
	notificationCounts: Map(),
});

export default function notificationsState(state = initialState, action) {
	switch (action.type) {
		case "NOTIFICATIONS:GETEVENTS@START": {
			return state.setIn(["mostRecentRequestID", "getEvents"], action.config.query.requestID);
		}
		case "NOTIFICATIONS:GETSCHEDULEDNOTIFICATIONS@START": {
			return state.setIn(["mostRecentRequestID", "getScheduledNotifications"], action.config.query.requestID);
		}
		case "NOTIFICATIONS:GETNOTIFICATIONEMAILS@START": {
			return state.setIn(["mostRecentRequestID", "getNotificationEmails"], action.config.query.requestID);
		}
		case "NOTIFICATIONS:GETEVENTS@SUCCESS": {
			const { requestID } = action.request.props.query;
			const mostRecentRequestID = state.getIn(["mostRecentRequestID", "getEvents"]);
			if (requestID !== mostRecentRequestID) {
				return state;
			}
			return state.withMutations((mutable) => {
				mutable.setIn(["events"], action.response.get("events", List()));
				mutable.setIn(["eventsCount"], action.response.get("eventsCount", 0));
			});
		}

		case "NOTIFICATIONS:GETSCHEDULEDNOTIFICATIONS@SUCCESS": {
			const { requestID } = action.request.props.query;
			const mostRecentRequestID = state.getIn(["mostRecentRequestID", "getScheduledNotifications"]);
			if (requestID !== mostRecentRequestID) {
				return state;
			}
			return state.withMutations((mutable) => {
				mutable.setIn(["scheduledNotifications"], action.response.get("scheduledNotifications", List()));
				mutable.setIn(["scheduledNotificationsCount"], action.response.get("scheduledNotificationsCount", 0));
			});
		}

		case "NOTIFICATIONS:GETNOTIFICATIONSNAPSHOTS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(
					["notificationSnapshots", action.response.get("environment")],
					action.response.get("notificationSnapshots", Map()).toJS()
				);
			});
		}

		case "NOTIFICATIONS:GETNOTIFICATIONEMAILS@SUCCESS": {
			const { requestID } = action.request.props.query;
			const mostRecentRequestID = state.getIn(["mostRecentRequestID", "getNotificationEmails"]);
			if (requestID !== mostRecentRequestID) {
				return state;
			}
			return state.withMutations((mutable) => {
				mutable.setIn(["notificationEmails"], action.response.get("notificationEmails", List()));
				mutable.setIn(["notificationEmailsCount"], action.response.get("notificationEmailsCount", 0));
			});
		}

		case "[] fetch notification raw email@SUCCESS": {
			const { id, email, emailSubject } = action.response.data;

			return state.withMutations((mutable) => {
				mutable.setIn(
					["notificationRawEmails", id],
					Map({
						email,
						subject: emailSubject,
					})
				);
			});
		}

		case "NOTIFICATIONS:GETNOTIFICATIONCOUNTS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["notificationCounts"], action.response);
			});
		}

		default:
			return state;
	}
}
